import script from "./Basket.vue?vue&type=script&setup=true&lang=js"
export * from "./Basket.vue?vue&type=script&setup=true&lang=js"

import "./Basket.vue?vue&type=style&index=0&id=21c7ab6c&lang=css"

const __exports__ = script;

export default __exports__